<template>
  <b-container class="wrap-archive">
    <b-row class="box-head">
      <b-col
        cols="12"
        md="8"
        class="box-breadcrumb"
      >
        <b-breadcrumb :items="breadcrumbs" />
      </b-col>

      <b-col
        cols="12"
        md="4"
        class="box-back-btn"
      >
        <button @click.prevent="goBack()">
          Back to archive
        </button>
      </b-col>
    </b-row>

    <b-col
      cols="12"
      class="box-title"
    >
      <h2 class="category-title">
        {{ categoryName }}
      </h2>

      <!-- <div class="category-box-detail">
        <div class="box" />
        <div class="content">
          <p>Fiction : Series or film</p>
          <hr>
        </div>
      </div> -->
    </b-col>

    <b-row v-if="isShow" class="wrap-content">
      <!-- @click.prevent="clickToDetail(category.id, category.name.toLowerCase())" -->
      <b-col
        v-for="archive in archives"
        :key="archive.id"
        cols="12"
        md="4"
        class="col"
      >
        <div
          @mouseover="hoverCard(archive.id, true)"
          @mouseleave="hoverCard(archive.id, false)"
        >
          <router-link
            :to="{
              name: 'programArchiveDetail',
              params: {
                year,
                categoryName,
                name: archive.name
              }
            }"
            class="card"
          >
            <div class="wrap-image">
              <img
                :src="archive.image"
                :alt="archive.name"
              >

              <div
                class="wrap-hover"
                :class="showDec === archive.id && isHover ? 'wrap-hover--open' : ''"
              >
                <div class="box-content">
                  <div class="box" />
                  <h3 v-html="archive.name" />>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="archives === []" class="wrap-empty">
      <p>No Data</p>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Home',
          to: {
            name: 'home'
          }
        },
        {
          text: 'Program Archive',
          to: {
            name: 'programArchive'
          }
        },
        {
          text: this.$route.params.categoryName.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
        }
      ],
      isShow: false,
      isHover: false,
      showDec: null
    }
  },

  computed: {
    ...mapState({
      categories: state => state.program.categories,
      archives: state => state.program.archives
    }),

    year () {
      return this.$route.params.year
    },

    categoryName () {
      return this.$route.params.categoryName
    }
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: 'https://admanawards.com' },
      { name: 'og:title', content: 'Adman Awards & Symposium 2019' },
      { name: 'og:description', content: 'งานประกวด แสดงผลงาน และแลกเปลี่ยนเรียนรู้ ของคนในวงการโฆษณาและการสื่อสารการตลาด' },
      { name: 'og:image', content: 'https://admanawards.com/img/og_adman.jpg' },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  },

  watch: {
    categories (categories) {
      if (categories) {
        categories.forEach((category) => {
          if (category.name.toLowerCase() === this.categoryName.toLowerCase()) {
            this.$store.dispatch('program/getArchives', {
              id: category.id,
              year: this.year
            })
          }

          this.isShow = true
        })
      }
    }
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'programArchive' })
    },

    hoverCard (index, status) {
      this.isHover = status

      if (status) {
        this.showDec = index
      } else {
        this.showDec = null
      }
    }
  },

  created () {
    this.$store.dispatch('program/getCategory')

    // const year = this.$route.params.year
    // const categoryName = this.$route.params.categoryName

    // this.$store.dispatch('program/getArchives', {
    //   year,
    //   categoryName
    // })
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-archive {
  .box-head {
      padding: 22px 0;
      border-bottom: 1px solid #CCC;

      .box-breadcrumb {
        display: flex;
        align-items: center;

        .breadcrumb {
          margin: 0;
          padding: 0;
          background: none;

          li {
            font-size: 1.25rem;

            a {
              color: black;
            }
          }
        }
      }

      .box-back-btn {
        margin-top: 22px;

        @media only screen and (min-width: $break-m) {
          margin-top: 0;
        }

        button {
          width: 100%;
          background-color: #CCC;
          padding: 12px 0;
          font-size: 1.25rem;
        }
      }
    }

  .box-title {
    .category-title {
      text-transform: uppercase;
      font-family: 'DB Helvethaica X 67 MedCond';
      letter-spacing: 10px;
      font-size: 68px;
      color: #6D6E71;
    }

    .category-box-detail {
      display: flex;

      .box {
        margin-top: 10px;
        width: 20px;
        height: 20px;
        background-color: #E10100;
      }

      .content {
        margin-left: 12px;
        width: 100%;

        p {
          font-size: 52px;
          line-height: 42px;
        }

        hr {
          opacity: 0.3;
          margin-top: 6px;
          width: 100%;
          border: 0.5px solid #58595B;
        }
      }
    }
  }

  .wrap-content {
    padding-bottom: 12px;

    .col {
      margin-top: 15px;
      margin-bottom: 15px;

      .card {
        border: 0;

        .wrap-image {
          overflow: hidden;
          position: relative;
          width: 100%;
          padding-bottom: 75%;

          img {
            position: absolute;
            border: 0;
            width: 100%;
            height: 100%;
            background-color: #ccc;
          }
        }
      }

      // .card:hover {
      //   background-color: $active;
      // }
    }
  }
}

.wrap-empty {
  display: flex;
  justify-content: center;
  padding-top: 22px;
  padding-bottom: 22px;

  p {
    font-size: 16px;
  }
}

.wrap-hover {
  transform: translateX(-100%);
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 22px;
  background-color: rgba(0, 0, 0, 0.8);

  .box-content {
    display: flex;
    width: 100%;
    height: 100%;
    padding: 12px;
    border: 2px solid white;

    .box {
      margin-top: 4px;
      width: 20px;
      height: 20px;
      background-color: red;
    }

    h3 {
      margin-left: 12px;
      width: 100%;
      text-transform: uppercase;
      line-height: 26px;
      font-size: 26px;
      color: white;
    }
  }
}

.wrap-hover--open {
  animation: open 300ms ease-out forwards;

  @keyframes open {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(0);
    }
  }
}
</style>
